<template>
  <div class="col-md-12">

    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('pay.title', 'Налаштування оплати') }}</h1>
      <router-link :to="{ name: 'AddPayments' }" class="default-btn btn-accent">
        {{ $static('pay.add-new', 'Додати') }}
      </router-link>
    </div>

    <div class="integrations-wrapper">
      <h2>{{ $static('pay.ff1', 'Активовано') }}</h2>

      <div class="integration-grid" v-if="list.length">
        <div class="integration-item active-item" v-for="(item, index) in list" :key="index">
          <div class="active-indicator">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.82 3.00001C13.82 2.79956 13.7003 2.61849 13.5159 2.53997C13.3314 2.46145 13.1179 2.50066 12.9734 2.6396L11.1955 4.34917C8.54827 6.89458 6.31144 9.83479 4.56461 13.0651C4.52348 13.1378 4.5 13.2217 4.5 13.3112C4.5 13.5873 4.72386 13.8112 5 13.8112H9.31V21C9.31 21.198 9.42684 21.3774 9.60795 21.4574C9.78907 21.5374 10.0003 21.503 10.1467 21.3696L10.9422 20.645C13.7269 18.1083 16.0902 15.1446 17.9432 11.865L18.4353 10.9942C18.5228 10.8394 18.5215 10.6498 18.4318 10.4962C18.3422 10.3426 18.1778 10.2482 18 10.2482H13.82V3.00001Z"
                fill="white" />
            </svg>
          </div>
          <div class="item-holder">
            <div class="logo" v-if="item.manifest && item.manifest.icon || item.manifest.name">
              <img v-if="item.manifest.icon" :src="item.manifest.icon" :alt="item.name">
              <p v-if="item.manifest.name">{{ item.manifest.name }}</p>
            </div>
            <div class="name" v-else>
              {{ item.name }}
            </div>
            <div class="button-panel">
              <a href="#" class="default-btn btn-remove" @click="disable(item)">
                <span class="text">{{ $static('pay.disable', 'Деактивувати') }}</span>
              </a>
              <Popper arrow :content="$static('pay.btnsettings', 'Налаштування оплати')" hover placement="top"
                style="white-space: nowrap">
                <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger" @click="openEditor(item)">
                  <span class="icon icon-settings"></span>
                </button>
              </Popper>

            </div>
            <!--            <div class="option-panel d-flex align-items-center justify-content-between">-->
            <!--              <button class=" btn-icon btn-medium btn-rounded btn-icon-transparent">-->
            <!--                <span class="icon icon-left"></span>-->
            <!--              </button>-->
            <!--              <div class="text">номер по порядку</div>-->
            <!--              <button class=" btn-icon btn-medium btn-rounded btn-icon-transparent">-->
            <!--                <span class="icon icon-right"></span>-->
            <!--              </button>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="panel-bordered panel" v-else>
        <div class="empty-text">{{ $static('pay.active-empty', 'У вас немає активованих способів оплати') }}</div>
      </div>
    </div>

    <div class="integrations-wrapper">
      <h2>{{ $static('pay.ff2', 'Деактивовано') }}</h2>

      <div class="integration-grid" v-if="disabled.length">
        <div class="integration-item" v-for="(item, index) in disabled" :key="index">
          <div class="item-holder">
            <div class="logo" v-if="item.manifest && item.manifest.icon || item.manifest.name">
              <img v-if="item.manifest.icon" :src="item.manifest.icon" :alt="item.name">
              <p v-if="item.manifest.name">{{ item.manifest.name }}</p>
            </div>
            <div class="name" v-else>
              {{ item.name }}
            </div>
            <p v-if="item.description" v-html="item.description"></p>
            <div class="button-panel">
              <button class="default-btn btn-white btn-green editor_trigger" @click="active(item)">
                <span class="text">{{ $static('pay.activate', 'Активувати') }}</span>
              </button>
            </div>
            <div class="button-panel">
              <button class="default-btn btn-white btn-remove editor_trigger" @click="remove(item)">
                <span class="text">{{ $static('pay.delete', 'Видалити') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-bordered panel" v-else>
        <div class="empty-text">{{ $static('pay.inactive-empty', 'У вас немає активованих способів оплати') }}</div>
      </div>
    </div>
  </div>


  <Teleport to="body">
    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor item-editor">
      <div class="overlay-editor-wrapper" v-if="selected">
        <div class="panel-top">

          <div class="lang-selector-holder d-flex align-items-center">
            <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
            <LangSelector v-model="lang"></LangSelector>
          </div>

          <a href="javascript:void(0);" class="back_trigger" @click="cancel">
            <span class="icon icon-cross"></span>
          </a>
        </div>

        <PluginEditor :selected="selected" :title="$static('pay.ff7', 'Редагування способу оплати')" :lang="lang" />

        <div class="panel-bottom">
          <button class="transparent-btn default-btn back_trigger" @click="cancel">
            <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
          </button>
          <button class="default-btn btn-accent" @click="save">
            <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
          </button>
        </div>
      </div>
    </div>
    <!--END EDITOR WRAPPER-->
  </Teleport>
</template>

<script>
import api from '@/api'
import LangSelector from '../components/LangSelector';
import PluginEditor from './PluginEditor';

export default {
  name: 'SettingsPayments',
  components: { PluginEditor, LangSelector },
  data() {
    return {
      lang: '',
      list: [],
      disabled: [],
      selected: undefined,
      load: false
    }
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      api.get('/api/plugin').then(response => response.data).then(data => {
        if (data) {
          let list = data.filter(i => i.type === 'payment');
          this.list = list.filter(i => i.status === 'active');
          this.disabled = list.filter(i => i.status !== 'active').filter(i => i.status === 'disable');
        }
      })
    },
    cancel() {
      this.selected = undefined;
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    remove(item) {
      api.delete('/api/plugin/' + item.id).then(() => {
        this.getList()
      });
    },
    disable(item) {
      item.status = 'disable';
      api.post('/api/plugin/update', { list: [item] }).then(() => {
        this.getList()
      });
    },
    active(item) {
      item.status = 'active';
      api.post('/api/plugin/update', { list: [item] }).then(() => {
        this.getList()
      });
    },
    openEditor(item, event) {
      this.selected = item;
      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    },
    save() {
      if (this.load) {
        return
      }
      this.load = true;
      this.selected.status = 'active';
      api.post('/api/plugin/install', this.selected).then(() => {
        this.load = false;
        this.cancel();
        this.$notify({
          title: this.$static('notify.payments-title', 'Оплати'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });
        // this.$router.push({name: 'SettingsPayments'})
      })
    }
  }
}
</script>

<style scoped></style>